import 'focus-visible'

import svg4Everybody from 'svg4everybody'

import setScrollbarCssVar from './common/set-scrollbar-css-var'

import { Application } from 'stimulus'
import { definitionsFromContext } from 'stimulus/webpack-helpers'
const controllers1 = require.context('./common/controllers', true, /\.js$/)
const controllers2 = require.context('./caregiver/controllers', true, /\.js$/)
const application = Application.start()
application.load(definitionsFromContext(controllers1, application))
application.load(definitionsFromContext(controllers2, application))

window.onload = () => {
  svg4Everybody();
  setScrollbarCssVar();
};
